// extracted by mini-css-extract-plugin
export default {"bubble":"G1CueB","content":"E1pETE","triangleWrapper":"VH9OBM","triangle":"S5vK4k"};